export enum NotificationObjectType {
  MESSAGE = 'message',
  REFERRAL = 'referral',
}

export enum NotificationVerb {
  // REFERRAL SHARES
  NEW_REFERRAL_SHARE = 'new_referral_share',
  REFERRAL_SHARE_RECEIVER_TIME_BASED = 'referral_share_receiver_time_based',
  REFERRAL_SHARE_SENDER_TIME_BASED = 'referral_share_sender_time_based',
  REFERRAL_SHARE_INTERESTED = 'referral_share_interested',
  REFERRAL_SHARE_APPROVED = 'referral_share_approved',
  REFERRAL_SHARE_RECEIVER_DECLINED = 'referral_share_receiver_declined',
  REFERRAL_SHARE_SENDER_DENIED = 'referral_share_sender_denied',
  REFERRAL_SHARE_EXPIRED = 'referral_share_expired',

  // LICENSE VERIFICATION
  LICENSE_VERIFICATION = 'license_verification',

  // POINTS
  POINTS_RECEIVED = 'points_received',
  WEEKLY_RECAP = 'weekly_recap',

  // LEAD CREDIT REWARD
  LEAD_CREDIT_REWARD_RECEIVED = 'lead_credit_reward_received',

  // FEED
  NEW_COMMENT_ON_POST = 'new_comment_on_post',
  NEW_COMMENT_ON_COMMENT = 'new_comment_on_comment',
  NEW_LIKE_ON_POST = 'new_like_on_post',
  NEW_LIKE_ON_COMMENT = 'new_like_on_comment',

  // PARTNER MATCH
  PARTNER_MATCH_WEEKLY_RESET = 'partner_match_weekly_reset',
  PARTNER_MATCH_UNLOCKED = 'partner_match_unlocked',

  // CHAT
  NEW_MESSAGE = 'new_message',
  REFERRAL_NEW_MESSAGE = 'referral_new_message',
  PARTNER_MATCH_NEW_MESSAGE = 'partner_match_new_message',
  NETWORK_NEW_MESSAGE = 'network_new_message',
  SNEAK_NEW_MESSAGE = 'sneak_new_message',

  // // SUBSCRIPTIONS
  // SUBSCRIPTION_CANCELED = 'subscription_canceled',
  // SUBSCRIPTION_EXPIRING = 'subscription_expiring',
  // SUBSCRIPTION_PAYMENT_FAILED = 'subscription_payment_failed',
  // SUBSCRIPTION_PAYMENT_SUCCEEDED = 'subscription_payment_succeeded',
  // SUBSCRIPTION_PAYMENT_EXPIRING = 'subscription_payment_expiring',

  // LEAD INQUIRY
  LEAD_INQUIRY_RECEIVED = 'lead_inquiry_received',
  LEAD_INQUIRY_REMINDER = 'lead_inquiry_reminder',
  LEAD_INQUIRY_COMPETITION = 'lead_inquiry_competition',
  LEAD_INQUIRY_TAKEN = 'lead_inquiry_taken',

  // One-time
  ONE_TIME = 'one_time',

  // SYSTEM
  SYSTEM = 'system',
}
